import React from "react";
import { useNavigate } from "react-router-dom";
import {useTheme, Box} from "@mui/material";

import {Container, StyledBox} from "../home/styles";
import NavBar from "../../components/navbar/navbar";
import {homeCards} from "../../utils/data";
import HomeCard from "../../components/homecard/homecard";


const Communications: React.FC = () => {
    const theme = useTheme();
    const navigate = useNavigate();

    const handleCardClick = (id: number) => {
        navigate("/article", {
            state: { id: id },
        });
    }
    const renderCards = () => {
        return homeCards.map((item) => (
            <HomeCard data={item} handleClick={handleCardClick} />
        ));
    };



    return(
        <Container>
            <NavBar active="comunicados"/>
            <Box textAlign="center">
                <StyledBox theme={theme}>
                    {renderCards()}
                </StyledBox>
            </Box>


        </Container>
    )
}

export default Communications;